module.exports = __webpack_public_path__ + "assets/loops-tree.2aa21238.svg";